var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg32IconShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-600.763 -2715.998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.339,
    cy: 2.339,
    r: 2.339,
    transform: "translate(617.172 2726.209) rotate(-30)",
    fill: "none",
    stroke: "#816920",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.339,
    cy: 2.339,
    r: 2.339,
    transform: "translate(608.299 2731.355) rotate(-30)",
    fill: "none",
    stroke: "#816920",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.847,
    transform: "translate(613.398 2731.026) rotate(-30)",
    fill: "none",
    stroke: "#816920",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.339,
    cy: 2.339,
    r: 2.339,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 619.257, 2733.729)",
    fill: "none",
    stroke: "#816920",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.847,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 613.104, 2733.404)",
    fill: "none",
    stroke: "#816920",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg32IconShare);
export default __webpack_public_path__ + "static/media/32-icon-share.d511f3ae.svg";
export { ForwardRef as ReactComponent };